import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import styles from './AddFeatureToCollectionModal.module.scss';
import Button from '../../Button';
import Alert from '../Alert';
import Checkbox from '../../Form/Checkbox';
import ghAnalytics from '../../../lib/analytics';
import AlertCircle from '../../../assets/svg/Feather/AlertCircle';

function AddFeatureToCollectionModal(props) {
  const [filterText, setFilterText] = useState('');
  const [collectionAddList, setCollectionAddList] = useState([]);

  const initCollections = () => {
    /*
      #NOTE: It's not possible to filter collections when there are multiple selectedFeatures.
      In that case, just return all collections. Only filter when there's 1 item in the selectedFeatures.
      -- KD - June 19, 2020
    */
    let collections = props.collectionsList.map((collectionItem) => {
      return {
        ...collectionItem,
        htmlTitle: collectionItem.title,
      };
    });

    /*
      #TODO: Temporarily removing the filtering of collections as
      we no longer get collection names returned, just collectionIds.
      This primarily affects selecting features from the content list,
      not featureDetail. Working on refactoring this functionality back.
      -- WD - September 01, 2020
    */
    // let filteredCollections = [];

    // if (props.selectedFeatures.length === 1) {
    //   const featureId = props.selectedFeatures[0];
    //   const selectedFeature = props.featuresList.find((feature) => feature.id === featureId);

    //   if (selectedFeature == null) {
    //     return filteredCollections = collections;
    //   }

    //   const featureColIdList = selectedFeature.collections.map((col) => col.id);

    //   filteredCollections = collections.filter((collection) => {
    //     return !featureColIdList.includes(collection.id);
    //   });
    // }
    // else {
    //   filteredCollections = collections;
    // }

    const filteredCollections = collections;

    return filteredCollections;
  };

  const [filteredList, setFilteredList] = useState(initCollections());

  useEffect(() => {
    setFilteredList(initCollections());
  }, [props.collectionsList]);

  const filterCollection = (e) => {
    e.stopPropagation();

    const text = e.target.value;
    const textLower = text.toLowerCase();

    setFilterText(text);

    let newFilteredList = props.collectionsList.map((item) => {
      const index = item.title.toLowerCase().indexOf(textLower);
      if (index !== -1) {
        const htmlTitle =
          item.title.substring(0, index) +
          '<b>' +
          item.title.substring(index, index + text.length) +
          '</b>' +
          item.title.substr(index + text.length);
        return {
          ...item,
          htmlTitle,
          // checked: false,
        };
      }
    });

    setFilteredList(newFilteredList);
  };

  const toggleCollection = (col) => {
    const index = collectionAddList.findIndex(
      (incol) => incol.uuid === col.uuid
    );

    if (index !== -1) {
      collectionAddList.splice(index, 1);
      setCollectionAddList([...collectionAddList]);
    } else {
      setCollectionAddList([col, ...collectionAddList]);
    }
  };

  const createNewCollection = (e) => {
    const collectionName = filterText;
    props.dispatch({
      type: 'collections/setCollectionsLoading',
      payload: true,
    }),

    props.dispatch({
      type: 'modals/add',
      payload: {
        component: Alert,
        props: {
          title: 'New Hunt',
          subtitle: `Create "${collectionName}"?`,
          actionItems: [
            {
              title: 'Cancel',
              theme: Button.THEME.outlinePrimary,
              onClick: () => {
                props.dispatch({
                  type: 'modals/close',
                });
              },
            },
            {
              title: 'Create',
              onClick: () => {
                props.dispatch({
                  type: 'collections/createCollectionEffect',
                  payload: collectionName,
                  callback: (collectionId) => {
                    props.dispatch({ type: 'modals/close' });

                    if (collectionId) {
                      ghAnalytics.logCollectionCreated(collectionId, collectionName);
                      props.dispatch({
                        type: 'collections/getCollectionEffect',
                        payload: collectionId,
                        callback: collection => {
                          props.dispatch({
                            type: 'collections/addNewHuntToUserData',
                            payload: collection
                          })
                          props.dispatch({
                            type: 'collections/setCollectionsLoading',
                            payload: false,
                          });
                        }
                      })
                    } else {
                      props.dispatch({
                        type: 'toast/show',
                        payload: {
                          text: 'There was an issue and your hunt was not saved',
                          icon: AlertCircle,
                          iconColor: '#ff3b30',
                          dismissable: true,
                        },
                      });
                    }
                  },
                });
              },
            },
          ],
        },
      },
    });
  };

  const addToList = (e) => {
    props.onAdd(collectionAddList, props.selectedFeatures);
  };

  return (
    <div className={styles.modal}>
      <h1 className={styles.title}>Add to Hunt</h1>

      <div>
        <input
          type='text'
          placeholder='Type here to search...'
          value={filterText}
          onChange={filterCollection}
        />
      </div>
      <div className={styles.collections}>
        {filteredList.map((item, index) => {
          if (!item) return null;
          return (
            <div key={index} className={styles.collectionItem}>
              <p
                className={styles.title}
                onClick={() => toggleCollection(item)}
                dangerouslySetInnerHTML={{ __html: item.htmlTitle }}
              />
              <Checkbox
                id={`collection-${item.uuid}`}
                checked={
                  collectionAddList.findIndex((col) => {
                    return item.uuid == col.uuid;
                  }) >= 0
                }
                onChange={() => toggleCollection(item)}
              />
              {/* <span >
                {
                  collectionAddList.findIndex((col) => { return item.id == col.id;}) >= 0 ?
                  <CheckSquare /> :
                  <Square />
                }
              </span> */}
            </div>
          );
        })}
      </div>
      <div className={styles.footer}>
        <Button
          theme={Button.THEME.solidPrimary}
          onClick={createNewCollection}
          disabled={filterText === ''}
        >
          Create new
        </Button>
        <div className={styles.actionsContainer}>
          <Button theme={Button.THEME.outlinePrimary} onClick={props.onClose}>
            Cancel
          </Button>
          <Button
            theme={Button.THEME.solidPrimary}
            onClick={addToList}
            disabled={collectionAddList.length < 1}
          >
            Add
          </Button>
        </div>
      </div>
    </div>
  );
}

AddFeatureToCollectionModal.propTypes = {
  collectionsList: PropTypes.array,
  currentUser: PropTypes.object,
  featuresList: PropTypes.array,
  selectedFeatures: PropTypes.array,
  // functions
  onAdd: PropTypes.func,
  onClose: PropTypes.func
};

export default connect((model) => {
  const { collections: { collectionsList }, features, user } = model
  const filteredCollectionsList = []
  let ci = 0, cl = collectionsList.length
  for (ci; ci < cl; ci++) {
    if (collectionsList[ci].isOwner) {
      filteredCollectionsList.push(collectionsList[ci])
    }
  }
  return {
    collectionsList: filteredCollectionsList,
    currentUser: user.currentUser,
    featuresList: features.featuresList,
  };
})(AddFeatureToCollectionModal);
